import React, {Component} from 'react';
import "./KeywordsViewer.css"
import "./commonAnalysisStyle.css"
import $ from "jquery";

const Highcharts = require('highcharts');
const autocomplete = require('./js/jquery.autocomplete')

class KeywordsViewer extends Component {

    chart = undefined

    constructor(props) {
        super(props);
        this.state = {backgroundColor: '#000000', listOfKeys: []}
    }


    componentDidMount() {

        let widget = this

        this.chart = Highcharts.chart(document.getElementById('chart_keyword'), {
                credits: {
                    enabled: false
                },
                tooltip: {enabled: false},
                chart: {
                    backgroundColor: 'transparent',
                    color: "#fff",
                    height: 300,
                    type: 'bar'
                },

                title: {
                    text: ''
                },
                yAxis: {
                    labels: {enabled: false},
                    gridLineColor: "transparent",
                    lineColor: "transparent",
                    title: null
                },
                xAxis: {
                    lineColor: "transparent",
                    gridLineColor: "transparent",
                    labels: {enabled: false},
                    tickColor: "transparent"

                },
                plotOptions: {
                    bar: {
                        stacking: 'normal',
                        color: "rgba(255,255,255,0.7)",
                        getExtremesFromAll: true,
                        dataLabels: {
                            enabled: true,
                            align: 'left',
                            color: '#86c069',
                            style: {
                                fontFamily: 'monospace',
                                textOutline: 0
                            },
                            formatter: function () {
                                if (this.point.isInside === true) {
                                    return '<span style="color: #86c069">' + this.x + '</span>';
                                } else {
                                    return '<span style="color: #ffffff">' + this.x + '</span>';
                                }
                            }
                        },
                        shadow: false,
                        states: {
                            hover: {
                                color: '#ffffff'
                            }
                        },
                        // allowPointSelect : true,
                        point : {
                            events : {
                                click : function() {
                                    let cat = this.category
                                    widget.props.callbackParent(cat);
                                }
                            }
                        }
                    },
                    series: {
                        pointPadding: 0,
                        groupPadding: 0.1,
                    }
                },

                series:
                    [{
                        showInLegend: false,
                        label: {enabled: false}
                    }]
            }
        )
        $('#keywordSearchBoxForm').submit(function(ev) {
            ev.preventDefault(); // to stop the form from submitting
            widget.props.callbackParent($("#keyword_search_box").val());
        });

    }


    update(parameters) {

        let barchart = this.chart

        let param = parameters
        if (param == undefined) {
            param = {
                corpusID: "deg",
                rangeYears: "all",
                sortmethod: "dataInsertion",
                sortdirection: "ASC",
                fileList: []
            }
        }

        this.setState({"fromTo": parameters.fromTo})

        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadKeywords",
            data: param,
            async: true,
            dataType: "json",
            success: function (data) {
                barchart.xAxis[0].setCategories(data.xAxis)
                barchart.series[0].setData(data.seriesData);
            }
        });

        let widget = this
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadKeyWordList",
            data: param,
            async: true,
            dataType: "json",
            success: function (data) {
                // console.log(data)
                widget.setState({listOfKeys: data}, () => {
                    let options = {
                        lookup: widget.state.listOfKeys,
                        minChars: 3,
                        deferRequestBy: 250
                    }
                    $("#keyword_search_box").autocomplete(options);
                })
            }
        });


    }


    render() {
        return (
            <div id="keyDashboard" className="KeywordWidgetStyle commonAnalysisFeatures">
                <center>
                    <div className="analisysTitle">Parole chiave</div>
                    <form id="keywordSearchBoxForm" className="form-wrapper">
                        <input id="keyword_search_box" type="text" placeholder="Cerca fra le parole chiave..." required/>
                        <button type="submit">Cerca</button>
                    </form>
                    <div id="chart_keyword"></div>
                </center>
            </div>
        );
    }
}

export default KeywordsViewer;


// WEBPACK FOOTER //
// ./src/components/KeywordsViewer.jsx